import {GET_DAILY_ACTIVITY_ERROR} from "../../reducers/dailyActivityReducer";


export const getDailyActivityError = (error) =>{
    return {
        type: GET_DAILY_ACTIVITY_ERROR,
        payload: {error}
    }
}